var map = {
	"./aberto.png": 3979,
	"./cintura.png": 6126,
	"./normal.png": 6457,
	"./pensativo.png": 5123,
	"./pensativo2.png": 5321,
	"./um.png": 7482,
	"./unhas.png": 137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7565;